// Prismic	
let Prismic = require('prismic-javascript');

// Import Drift Zoom
import Drift from 'drift-zoom';
const main = document.querySelector('main')
const $popup = main.querySelector('.popup-container')
const $closeBtn = main.querySelector('.popup-close')
let $popupOpeners = main.querySelectorAll('.boutiqueImageContainer')
 
let apiEndpoint = "https://olivier-geffard.prismic.io/api/v2";
 
Prismic.getApi(apiEndpoint).then(function(api) {
  return api.getByID('YDSuwREAACkATcIv'); // An empty query will return all the documents
}).then(function(response) {
  let paintings = response.data.aquarelles
  paintings.reverse()

  for (const painting of paintings) {
    const container = document.createElement('div')
    container.classList.add('boutiqueImageContainer')
    const imageContainer = document.createElement('img')
    const textContainer = document.createElement('div')
    textContainer.classList.add('galery_text')
    const text = document.createElement('p')
    // Add data-price, data-title, data-description to container
    container.setAttribute('data-title', painting.title[0].text)
    container.setAttribute('data-price', painting.price)
    let str = painting.description[0].text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    container.setAttribute('data-description', str)

    imageContainer.setAttribute('src', painting.aquarelle.url)
    text.innerHTML = painting.title[0].text

    container.appendChild(imageContainer)
    textContainer.appendChild(text)
    container.appendChild(textContainer)
    main.appendChild(container)
  }
  $popupOpeners = main.querySelectorAll('.boutiqueImageContainer')

  // Open popup
  for(const $popupOpener of $popupOpeners) {
    $popupOpener.addEventListener(
      'click',
      () => {
        if(!$popup.classList.contains('open')) {
          $popup.classList.add('open')
          const $imgSrc = $popupOpener.querySelector('img').getAttribute('src')
          const $popupImg = $popup.querySelector('img')
          const $checkoutBtn = $popup.querySelector('#checkout-button')
          // get data-price, data-title, data-description from $popupOpener
          $popupImg.setAttribute('src', $imgSrc)
          $popupImg.setAttribute('data-zoom', $imgSrc)
          $popup.querySelector('.popup-title').innerHTML = $popupOpener.getAttribute('data-title')
          $popup.querySelector('.popup-description').innerHTML = $popupOpener.getAttribute('data-description')
          $popup.querySelector('.popup-price').innerHTML = `Prix : ${$popupOpener.getAttribute('data-price')}€`
          
          // Transform price to integer for stripe
          const stripePrice = $popupOpener.getAttribute('data-price') * 100

          // give product data to button
          $checkoutBtn.setAttribute('data-productName', $popupOpener.getAttribute('data-title'))
          $checkoutBtn.setAttribute('data-productSrc', $imgSrc)
          $checkoutBtn.setAttribute('data-productPrice', stripePrice)
        }
      }
    )
  }

}, function(err) {
  console.log("Something went wrong: ", err);
});

// Close popup
$closeBtn.addEventListener(
  'click',
  () => {
    if($popup.classList.contains('open')) {
      $popup.classList.remove('open')
    }
  }
)

// Drift logic
// let drift = new Drift($popup.querySelector('img'), {
//   paneContainer: $popup.querySelector('.second'),
//   // containInline: true,
//   // showWhitespaceAtEdges: false,
//   //inlinePane: true,
//   //zoomFactor: 1.5
// });
//drift.disable();

// new Drift($popup.querySelector('img'), {
//   paneContainer: $popup.querySelector('.popupImageContainer'),
//   inlinePane: false,
//   //zoomFactor: 2
// });
new Drift($popup.querySelector('img'), {
  inlinePane: true,
  containInline: true,
  // inlinePane: 105,
  zoomFactor: 2.8
});